import { NotificationReadUser } from './notification-read-user.model';

export interface Notificacion {
  id: number;
  usuarioId: number;
  titulo: string;
  mensaje: string;
  tipo: TipoNotificacion;
  leida: boolean;
  fechaCreacion: string;
  datos?: any;
  senderName?: string; // Nombre del remitente
  senderId?: number; // ID del remitente
  recipientId?: number; // ID del destinatario
  recipientName?: string; // Nombre del destinatario
  // Añade estas nuevas propiedades
  readers?: NotificationReadUser[]; // New property
  readCount?: number; // New property
  // Tipo original del backend para distinguir BROADCAST de USER_MESSAGE
  backendType?: string; // BROADCAST, USER_MESSAGE, etc.
  // Información de sede destino
  sedeId?: number;
  sedeName?: string;
}

export enum TipoNotificacion {
  INFO = 'INFO',
  EXITO = 'EXITO',
  ADVERTENCIA = 'ADVERTENCIA',
  ERROR = 'ERROR',
  SISTEMA = 'SISTEMA',
}